import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import HeroSection from './components/HeroSection';
import DailyRecommend from './components/DailyRecommend';
import CategoryNav from './components/CategoryNav';
import HotWorks from './components/HotWorks';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  return (
    <>
      <SEOSchema type="organization" />
      <SEOSchema type="website" />
      <SEOSchema
        type="webpage"
        data={{
          name: `${siteInfo.name} - ${siteInfo.tagline}`,
          description: siteInfo.description,
          url: siteInfo.url,
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <DailyRecommend />
        <CategoryNav />
        <HotWorks />
        <LatestUpdates />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}